import { Formik } from 'formik';
import { Group } from '@mantine/core';
import { I18n } from '@aws-amplify/core';
import { FlexiButton, FlexiCancelButton } from '@flexinet/ui-components';
import { MdClear, MdCheck } from 'react-icons/md';
import { FilterFormComponent } from './FilterFormComponent';
import { FilterFormSchema } from './FilterFormSchema';
import { useUsersFilter } from '../../hooks/useUsersFilter';

interface FilterFormProps {
    onApply: () => void;
    onCancel: () => void;
}

interface FilterFormValues {
    status?: string;
}

export const FilterForm = ({ onApply, onCancel }: FilterFormProps) => {
    const { filters, handleSetFilters, handleClearFilters } = useUsersFilter();

    const initialValues: FilterFormValues = {
        status: filters.status || '',
    };

    const onSubmit = (values: FilterFormValues) => {
        const cleanFilters = Object.entries(values).reduce((acc, [key, value]) => {
            if (value && value !== '') {
                acc[key] = value;
            }
            return acc;
        }, {} as Record<string, string>);

        handleSetFilters(cleanFilters);
        onApply();
    };

    const handleClear = () => {
        handleClearFilters();
    };

    // Clear resets the FIELDS to empty, not to initialValues: initialValues are
    // the current filter, so resetting to them left the old status checked and
    // the next Apply brought it back (FNP-2015).
    const EMPTY: FilterFormValues = {status: ''};

    return (
        <Formik<FilterFormValues>
            initialValues={initialValues}
            validationSchema={FilterFormSchema}
            onSubmit={onSubmit}
        >
            {({ handleSubmit, resetForm }) => (
                <>
                    <FilterFormComponent />

                    <Group justify="space-between" mt="xl">
                        <FlexiCancelButton onClick={onCancel}/>
                        <Group gap="xs">
                            <FlexiButton
                                variant="outline"
                                leftSection={<MdClear />}
                                onClick={() => {
                                    resetForm({values: EMPTY});
                                    handleClear();
                                }}
                            >
                                {I18n.get('Clear')}
                            </FlexiButton>
                            <FlexiButton
                                variant="filled"
                                leftSection={<MdCheck />}
                                onClick={() => handleSubmit()}
                            >
                                {I18n.get('Apply')}
                            </FlexiButton>
                        </Group>
                    </Group>
                </>
            )}
        </Formik>
    );
};
